import { render, staticRenderFns } from "./TheLoading.vue?vue&type=template&id=8dd39b38"
import script from "./TheLoading.vue?vue&type=script&lang=js"
export * from "./TheLoading.vue?vue&type=script&lang=js"
import style0 from "./TheLoading.vue?vue&type=style&index=0&id=8dd39b38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports